import { render, staticRenderFns } from "./QuitModal.vue?vue&type=template&id=645ae3f8&scoped=true&"
import script from "./QuitModal.vue?vue&type=script&lang=ts&"
export * from "./QuitModal.vue?vue&type=script&lang=ts&"
import style0 from "./QuitModal.vue?vue&type=style&index=0&id=645ae3f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645ae3f8",
  null
  
)

export default component.exports